import { Box } from '@mui/material';
import { CustomDialog } from 'components/common/CustomDialog';
import { theme } from 'styles/theme';
import {
  SocialMediaListeningPostDetailView,
  SocialMediaListeningPostDetailViewProps,
} from './SocialMediaListeningPostDetailView';

type Props = {
  brandId: string;

  copyLink?: string;

  title?: string;
  isOpen: boolean;
  onClose: () => void;

  postId: string;
  topicIds?: string[];
  searchParams?: URLSearchParams;
  componentProps?: {
    socialMediaListeningPostDetailView?: Partial<SocialMediaListeningPostDetailViewProps>;
  };
};

export const SocialMediaListeningPostDetailDialogView = ({
  brandId,
  title,
  isOpen,
  onClose,
  postId,
  topicIds = [],
  searchParams,
  copyLink,
  componentProps,
}: Props) => {
  return (
    <CustomDialog
      open={isOpen}
      onClose={onClose}
      titleBreadcrumbs={title ? [title] : []}
      onBackClick={onClose}
      copyLink={copyLink}
    >
      <Box display="flex" alignItems="center" pt={10} pb={12} px={32}>
        <SocialMediaListeningPostDetailView
          brandId={brandId}
          socialPostId={postId}
          searchParams={
            // social listening post detail dialog accepts searchCriteria as a query param to apply a filter on the detail page from the list page
            new URLSearchParams({
              ...Object.fromEntries(searchParams?.entries() ?? []),
              searchCriteria: window.btoa(
                JSON.stringify({ filters: { topicIds } }),
              ),
            })
          }
          componentProps={{
            modalView: true,
            socialMediaListeningPostAnalysisView: {
              componentProps: {
                container: {
                  sx: {
                    backgroundColor: theme.colors?.primary.white,
                    maxHeight: '938px',
                  },
                },
              },
            },
          }}
          {...componentProps?.socialMediaListeningPostDetailView}
        />
      </Box>
    </CustomDialog>
  );
};
